class MasonryGrid {
    constructor(container) {
        this.container = document.querySelector(container);
        this.minItemWidth = 240; // минимальная ширина блока
        this.gap = this.container.dataset.gap ? this.container.dataset.gap : 16; // расстояние между элементами
        this.resizeTimeout = null; // Для дебаунсинга
        this.columnCount = this.container.dataset.columns ? this.container.dataset.columns : 3; // Количество колонок по умолчанию
        this.init();
        window.addEventListener('resize', () => {
            clearTimeout(this.resizeTimeout);
            this.resizeTimeout = setTimeout(this.init.bind(this), 100);
        });
        this.container.classList.add('active');
    }

    init() {
        console.log(111)
        // requestAnimationFrame для оптимизации 
        requestAnimationFrame(() => {
            this.updateColumns();
            this.positionItems();
        });
    }

    updateColumns() {
        const containerWidth = this.container.clientWidth;
        this.columns = [];

        let calcColumnCount = Math.floor(containerWidth / (this.minItemWidth + this.gap)); // Вычисляем количество колонок, исходя из минимальной ширины и отступов
        let columnCount = Math.min(calcColumnCount, this.columnCount); // Ограничиваем максимальное количество колонок количеством по умолчанию
        const availableWidth = containerWidth - (this.gap * (columnCount - 1));
        columnCount = Math.max(columnCount, 1); // Гарантируем минимум одну колонку
        const columnWidth = availableWidth / columnCount; // Рассчитываем ширину каждой колонки

        for (let i = 0; i < columnCount; i++) {
            this.columns[i] = {
                height: 0,
                x: i * (columnWidth + this.gap),
            };
        }

        const items = Array.from(this.container.children);

        items.forEach(item => {
            let colspan = item.classList.contains('grid-item--double') ? 2 : 1;
            colspan = Math.min(colspan, columnCount);

            // Задаем ширину элемента с учетом количества занимаемых колонок и отступов
            let itemWidth = columnWidth * colspan + this.gap * (colspan - 1);
            item.style.width = `${itemWidth}px`; // Обновляем стиль ширины для каждого элемента
        });
    }

    positionItems() {

        const items = Array.from(this.container.querySelectorAll('.grid-item:not(.d-none)'));
        let minColumn = 0;

        items.forEach((item, index) => {

            if (index > 0) minColumn++;

            if (minColumn == this.columns.length) minColumn = 0;

            let isDouble = item.classList.contains('grid-item--double') && this.columns.length > 1;
            const span = isDouble ? 2 : 1;

            if (span > 1 && minColumn == this.columns.length) {
                // если элемент двойного размера и минимальная колонка - последняя, переключаемся на предпоследнюю
                minColumn--;
            }

            const posX = this.columns[minColumn].x;
            const posY = this.columns[minColumn].height;

            item.style.position = 'absolute';
            item.style.top = `${posY}px`;
            item.style.left = `${posX}px`;

            // Обновляем высоту колонок, которые занимает элемент
            for (let i = 0; i < span; i++) {
                this.columns[minColumn + i].height = posY + item.offsetHeight + this.gap;
            }

            if (span > 1  && minColumn != this.columns.length) {
                // сдвигаем следующую после двойной карточку
                if (minColumn == 0 ) minColumn++;
            }
        });

        // Обновляем высоту контейнера
        this.container.style.height = `${Math.max(...this.columns.map(col => col.height))}px`;
    }
}

document.addEventListener('DOMContentLoaded', () => {
    window.masonry = new MasonryGrid('.grid-masonry');
    window.dispatchEvent(new Event('resize'));
});

function updateGrid() { window.masonry.init() };